import { Component, Input } from '@angular/core';
import { AbstractControl, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';

@Component({
  selector: 'korviu-checkbox',
  standalone: true,
  imports: [NzCheckboxModule, FormsModule, ReactiveFormsModule],
  templateUrl: './korviu-checkbox.component.html',
  styleUrls: ['./korviu-checkbox.component.scss']
})
export class KorviuCheckboxComponent {
  @Input() control: AbstractControl;
  public get formControl(): FormControl {
    return this.control as FormControl;
  }

  constructor() {}
}
